import { IFirmwareConfig } from ".";

export const DR900X_Plus = {
  default: {
    Time: {
      GpsSync: {},
      TimeSet: {},
    },
    Video: {
      ImageSetting: {
        options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
      },
      VideoQuality: {
        options: [
          { key: "0", value: "Highest(Extreme)" },
          { key: "1", value: "Highest" },
          { key: "2", value: "High" },
          { key: "3", value: "Normal" },
        ],
      },
    },

    Recording: {
      NormalRecord: {},
      AutoParking: {},
      RearParkingMode: {
        explain: "ON: front and_",
      },
      VoiceRecord: {},
      DateDisplay: {},
      SpeedUnit: {},
      UseGpsInfo: {},
      RecordTime: {
        options: [
          {
            key: "1",
            value: "1 min",
          },
        ],
      },
      LockEvent: {},
      overWriteLock: {},
      FrontRotate: {},
      RearRotate: {
        options: [
          {
            key: "0",
            value: "Default",
          },
          {
            key: "1",
            value: "Rotate video 180°",
          },
          {
            key: "2",
            value: "Mirror video",
          },
        ],
      },
    },
    Gsensor: {
      Normal: {},
      Parking: {},
    },
    MotionDetection: {
      MOTIONSENSOR: {},
    },
    System: {
      LED: {
        RECLED: {},
        NORMALLED: {},
        PARKINGLED: {},
        RearLED: {},
        WifiLED: {},
        LTELED: {},
        BTLED: {},
      },
      PSENSOR: {},
      VoiceGuidance: {
        STARTVOICE: {},
        NORMALSTARTVOICE: {},
        EVENTSTARTVOICE: {},
        CHANGERECORDMODEVOICE: {},
        ENDVOICE: {},
        SPEEDALERTVOICE: {},
        SHARPTURNVOICE: {},
        HARSHBRAKINGVOICE: {},
        ACCELERATIONVOICE: {},
        CHANGECONFIGVOICE: {},
        CLOUDVOICE: {},
        PARKINGEVENTVOICE: {},
      },
      VOLUME: {},
      ScheduledReboot: {},
      SpeedAlert: {},
      BatteryProtectionRev: {
        minVolt: 11.8,
        maxVolt: 12.5,
        defaultVolt: 12,
        minVoltHeavy: 22.8,
        maxVoltHeavy: 24,
        defaultVoltHeavy: 23.2,
        defaultTime: "1200",
        minTime: "100",
        maxTime: "4800",
        LowvoltageVolt: {
          "1": "1180",
          "2": "1200",
          "3": "1250",
        },
        LowvoltageVoltHeavy: {
          "1": "2280",
          "2": "2320",
          "3": "2400",
        },
      },
      EventRev: {},
      UserTextOverlay: {},
    },
    Wifi: {
      LoginCredentials: {},
      WifiBand: {},
      WifiSleepMode: {},
    },
    Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
    FirmwareLanguage: [
      "English",
      "Japan",
      "Spain",
      "French",
      "Italian",
      "German",
      "China",
      "Dutch",
      "Thai",
      "Idn",
      "Vietnam",
      "Polish",
      "Norwegian",
      "Finnish",
      "Arabic",
      "Korea",
    ],
  } as IFirmwareConfig,
  1.003: {
    System: {
      Seamless: {},
    },
  } as IFirmwareConfig,
  1.006: {
    DMS: {},
  } as IFirmwareConfig,
  1.008: {
    System: {
      EventRev: undefined,
      EventRev2: {},
    },
  } as IFirmwareConfig,
  1.009: {
    CloudNative: {},
    // CloudNative3: {},
  },
};
